<template>
  <div>
    <h1 class="title">L'Oil Bowl per un pelo splendente!</h1>
    <p class="subtitle">
      L’Oil Bowl è un olio complementare che perfeziona la naturale
      <strong>lucentezza del pelo!</strong><br />
      Oltre a rendere la pappa più buona, è anche salutare visto che contiene
      tantissimo <strong>Omega3</strong>!
    </p>
    
    <form class="form" @submit.prevent>
      <div class="form-group">
        <div
          class="switch-container"
          :class="[dog.oilSlug == null ? 'switch-empty' : '']"
        >
          <label
            for="oil_yes"
            class="switch-option"
            :class="[dog.oilSlug == 1 ? 'active-option' : 'inactive-option']"
          >
            <input
              v-model.number="$v.dog.oilSlug.$model"
              class="hidden"
              type="radio"
              id="oil_yes"
              value="1"
            />
            <span>Lo aggiungo subito</span>
          </label>
          <label
            for="oil_no"
            class="switch-option"
            :class="[dog.oilSlug == 0 ? 'active-option' : 'inactive-option']"
          >
            <input
              v-model.number="$v.dog.oilSlug.$model"
              class="hidden"
              type="radio"
              id="oil_no"
              value="0"
            />
            <span>Ci penserò dopo</span>
          </label>
        </div>
        <div v-if="$v.dog.oilSlug.$error" class="error">campo obbligatorio</div>
        <img
          :src="getImageUrl('questionario_nonnacane_olio.jpg')"
          alt=""
          class="w-64 h-64 block mx-auto"
        />
      </div>

      <a
        class="underline inline-block text-sm italic py-2 cursor-pointer"
        v-on:click.stop="openModal()"
        >Maggiori info</a
      >

      <VideoPopup
        ref="videopopup"
        :intervalTime="10"
        :videoDesktopUrl="videoDesktopUrl"
        :videoMobileUrl="videoMobileUrl"
      >
      </VideoPopup>
    </form>
  </div>
</template>

<script>
  import { required } from "vuelidate/lib/validators";
  import camelcaseKeys from "camelcase-keys";
  import snakecaseKeys from "snakecase-keys";
  import VideoPopup from "./VideoPopup.vue";

  export default {
    components: {
      VideoPopup
    },
    props: {
      wizardData: {
        type: Object,
        required: true,
      },
      dogData: {
        type: Object,
        required: true,
      },
    },
    data() {
      return {
        videoDesktopUrl: "https://player.vimeo.com/video/783361994?h=3bbf150913",
        videoMobileUrl: "https://player.vimeo.com/video/783361720?h=f47a465cbc",
        prices: [],
        dog: {
          oilSlug: this.dogData.oilSlug,
        },
      };
    },
    validations: {
      dog: {
        oilSlug: {
          required,
        },
      },
    },
    watch: {
      dog: {
        deep: true,
        handler: "getPrices",
      },
    },
    computed: {
      showNumberOfDogs() {
        return this.wizardData.numberOfDogs > 1 && this.wizardData.sameDiet;
      },
    },
    methods: {
      getUrl(value) {
        return this.$hostname + "/" + value;
      },
      getImageUrl(value) {
        return this.getUrl("wp-content/uploads/2022/12/" + value);
      },
      openModal () {
        this.$refs.videopopup.openModal();
      },
      submit() {
        this.$v.$touch();
        return new Promise((resolve, reject) => {
          if (!this.$v.$invalid) {
            resolve({
              dog: {
                oilSlug: this.dog.oilSlug,
              },
            });
          } else {
            reject("invalid entry");
          }
        });
      },
      async getPrices() {
        this.$emit("barAsyncState", "pending");

        var updatedData = [];
        var dog = [];
        updatedData = Object.assign({}, this.wizardData);

        // get prices to only one dog if different diet
        // otherwise get prices to all
        if (this.wizardData.numberOfDogs >= 2 && !this.wizardData.sameDiet) {
          updatedData.numberOfDogs = 1;
          updatedData.dogs = [];
          dog = Object.assign(this.dogData, this.dog);
          updatedData.dogs.push(dog);
        } else if (
          this.wizardData.numberOfDogs >= 2 &&
          this.wizardData.sameDiet
        ) {
          // first needs to update all dogs with isDoubleTaste, oilSlug, extraIngredientIds, seasonalVegetables
          for (let i = 0; i < this.wizardData.numberOfDogs; i++) {
            Object.assign(updatedData.dogs[i], this.dog);
          }
        } else {
          Object.assign(updatedData.dogs[updatedData.indexDog], this.dog);
        }

        const requestOptions = {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(
            snakecaseKeys({
              form: updatedData,
              selectedRecipeId: this.dogData.recipeId,
            })
          ),
        };
        let url = this.$restAPIurlRB + "recipe-prices";
        const response = await fetch(url, requestOptions);
        const data = await response.json();
        var camelcaseData = camelcaseKeys(data, { deep: true });
        this.prices = camelcaseData.recipes;
        this.$emit("prices", this.prices);
        this.$emit("barAsyncState", "success");
      },
    },
    activated() {
      this.dog.oilSlug = this.dogData.oilSlug;
      this.$v.$reset();
      this.getPrices();
    },
    mounted() {
      this.getPrices();
    },
  };
</script>

<style scoped></style>
